import { render, staticRenderFns } from "./GuidelinesManage.vue?vue&type=template&id=352cac56&scoped=true"
import script from "./GuidelinesManage.vue?vue&type=script&lang=js"
export * from "./GuidelinesManage.vue?vue&type=script&lang=js"
import style0 from "./GuidelinesManage.vue?vue&type=style&index=0&id=352cac56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352cac56",
  null
  
)

export default component.exports